<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title">
        <span class="fonints">计划单号</span>
        <el-input placeholder="请输入关键词" v-model="conditions.pno" clearable>
        </el-input>
        <span class="fonints">车牌号码</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.plate"
          clearable
        >
        </el-input>
        <span class="fonints">货主名称</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.customname"
          clearable
        >
        </el-input>
      </div>
      <div class="componentSty_content_title">
        <span class="fonints">代理名称</span>
        <el-input
          placeholder="请输入关键词"
          v-model="conditions.agentname"
          clearable
        >
        </el-input>
        <span class="fonints">货场名称</span>
        <div class="select_box">
          <m-select :list="selectastrict" v-model="selectinfo"></m-select>
        </div>
        <button class="buttons" @click="selectlist">查询</button>
      </div>
      <div class="componentSty_content_title">
        <button
          class="buttons"
          style="background:#17B6A1"
          @click="approved(true)"
        >
          审核通过
        </button>
        <!-- <button
          class="buttons"
          style="background: #ff5926"
          @click="approved(false)"
        >
          审核不通过
        </button> -->
      </div>
      <div class="componentSty_content_table" style="top: 135px;border:none">
        <el-table
          :data="arrlist.data"
          style="width: 100%;"
          @sort-change="sortchange"
          @selection-change="selChange"
           height="80%"
           border
        >
          <el-table-column show-overflow-tooltip :render-header="renderHeader"
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" type="selection"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader"
            prop="pno"
            label="计划单号"
            sortable="custom"
          ></el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="storename" label="货场名称"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="customname" label="货主名称">
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="agentname" label="代理名称"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="custmername" label="流向"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="fleetname" label="代理名称"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="plate" label="车牌号"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="计划吨数">
            <template v-slot="res">
              <span>{{ res.row.plantons }}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="审核时间" :render-header="renderHeader">
            <template v-slot="res">
              <span>{{ mydateFormat(res.row.checkedtime, "时分秒") }}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="操作">
            <template v-slot="res">
              <span
                @click="iteminfofun(res.row)"
                class="iconfont icon-chakan"
              ></span>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginations" v-show="arrlist.data && arrlist.data.length">
          <el-pagination
            :page-size="conditions.limit"
           layout="total,prev, pager,next, jumper"
            :total="arrlist.count"
            :current-page="conditions.page"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import mSelect from "@/components/mSelect";
import { mapMutations, mapState } from "vuex";
import { antiShake } from "@/plugins/other.js";
export default {
  data() {
    return {
      selectastrict: [],
      listitem: [{ name: "审核管理" }, { name: "进场取消" }],
      selectinfo: "全部",
      conditions: {},
      arrlist: [],
      ids: [],
      platelist:[]
    };
  },
  computed: {
    ...mapState(["conditionsList"]),
  },
  created() {
    this.conditionsList[this.$route.path] ||
      this.createConditions({ key: this.$route.path });
    this.conditions = this.conditionsList[this.$route.path] || {
      page: 1,
      limit: 20,
    };
    this.getarrlist();
    this.getselectastrict();
  },
  components: {
    mTitle,
    mSelect,
  },
  methods: {
    ...mapMutations(["createConditions", "addnavigationMsg"]),
    async getarrlist() {
      this.selectinfo == "全部"
        ? (this.conditions.storename = null)
        : (this.conditions.storename = this.selectinfo);
      for (var i in this.conditions) {
        if (!this.conditions[i]) this.conditions[i] = null;
      }
      const { data } = await this.$http(
        "api1",
        "/driver/dispatchtruck/offlinePaymentCancelList",
        "post",
        this.conditions
      );
      if (!data.data) return;
      this.arrlist = data;
    },
    async getselectastrict() {
      const { data } = await this.$http("api1", "/sys/dic/list", "get", {
        dictionaryType: "货场",
      });
      if (!data.data) return;
      this.selectastrict = ["全部"];
      data.data.forEach((item) => {
        this.selectastrict.push(item.val);
      });
    },
    selectlist() {
      antiShake((_) => {
        this.conditions.page = 1;
        this.getarrlist();
      });
    },
    sortchange(event) {
      if (event.order == "ascending") {
        this.conditions.sidx = event.prop;
        this.conditions.order = "asc";
      } else if (event.order == "descending") {
        this.conditions.sidx = event.prop;
        this.conditions.order = "desc";
      } else {
        this.conditions.sidx = "";
        this.conditions.order = "";
      }
      this.getarrlist();
    },
    selChange(event) {
      this.ids = [];
      this.platelist = [];
      event.forEach((item) => {
        this.ids.push(item.id);
        this.platelist.push(item.plate);
      });
    },
    handleCurrentChange(index) {
      if (this.arrlist.count < this.conditions.limit) return;
      this.conditions.page = index;
      this.getarrlist();
    },
    approved(info) {
      if (!this.ids.length) return "";
      if (this.ids.length > 1)
        return this.$message.info("当前只允许通过单条数据");
      var path = "",
        title = "",
        successifo = "";
      if (info) {
        path = "/driver/dispatchtruck/offlinePaymentCancelDispatch";
        title = "是否通过";
        successifo = "审核已通过";
      } else {
        return "";
      }
      this.$messageBox
        .confirm(`${title}?`,`${this.platelist+''||'提示'}`, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          const { data } = await this.$http("api1", path, "post", {
            ids: this.ids,
          });
          if (data.code == 500) return this.$message.error(data.msg);
          this.$message.success(successifo);
          this.getarrlist();
        })
        .catch((err) => err);
    },
    iteminfofun(obj) {
      this.addnavigationMsg([
        { name: "审核管理" },
        { name: "线下取消", path: "/audit/offlinetocancel" },
        { name: "详情" },
      ]);
      this.$router.push("/audit/infomsg/" + obj.id);
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>